export const MAX_STAGE_NAME_LENGTH = 40;

export type StageNameError = 'required' | 'duplicate';

const NAME_REQUIRED = 'PROJECT_STAGE_NAME_REQUIRED';
const NAME_ALREADY_EXISTS = 'PROJECT_STAGE_NAME_ALREADY_EXISTS';

const normalise = (name: string): string => name.trim().toLowerCase();

/**
 * The same rule the server applies: a name is required after trimming, and may not match any other
 * stage's name ignoring case. otherNames holds every stage's stored name (the defaults' English names
 * included) except the stage being edited.
 */
export const validateStageName = (name: string, otherNames: ReadonlyArray<string>): StageNameError | null => {
	const candidate = normalise(name);
	if (candidate === '') {
		return 'required';
	}
	return otherNames.some(other => normalise(other) === candidate) ? 'duplicate' : null;
};

/** The inline error for a server refusal, or null when the error belongs to the default handling. */
export const stageNameErrorFromServer = (error: unknown): StageNameError | null => {
	const message = String(error);
	if (message.includes(`${NAME_REQUIRED}:`)) {
		return 'required';
	}
	if (message.includes(`${NAME_ALREADY_EXISTS}:`)) {
		return 'duplicate';
	}
	return null;
};
